import { Directive, HostListener } from '@angular/core';

/** Useful Directive that allows us to contain clicks within an element */
@Directive({
    selector: '[sciStopClick]'
})
export class StopClickDirective {
    @HostListener('click', [ '$event' ])
    public onClick(event: any): void {
        event.stopPropagation();
    }
}
